
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"m21.41 11.88 2.837 7.348 7.367.636L26 25.042l1.715 7.74-6.307-4.147-6.306 4.148 1.714-7.741-5.612-5.178 7.367-.636z"}}),_c('path',{staticClass:"i-Star 11",attrs:{"stroke":"#234652","stroke-width":".962","d":"M24.449 12.356 24 11.194l-.449 1.162-2.097 5.43-5.426.47-1.086.093.8.74 4.16 3.836-1.273 5.746-.257 1.158.99-.652L24 26.127l4.637 3.05.99.652-.256-1.158-1.273-5.746 4.16-3.837.8-.739-1.086-.094-5.426-.468z"}}),_c('path',{staticClass:"i-speech-bubble",attrs:{"stroke":"#234652","d":"m17.354 34.646-.147-.146H4.5v-28h39v28H30.793l-.147.146L24 41.293z"}})])
          )
        }
      }
    